import React, { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import { bool } from 'prop-types'
import { navigate } from '@reach/router'
import { TypographyV2 as Typography } from '@taglivros/tag-components'
import { useGlobal } from '../../contexts/GlobalContext'
import { getVendasPorAssinatura } from '../../api/assinatura.servico'
import { escolherPlano, getPlanoPorModalidade } from '../../api/planos.servico'
import BaseCard from '../../components/BaseCard/BaseCard'
import InlineLoader from '../../components/InlineLoader/InlineLoader'
import * as S from './style'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, ROUTE_BASEPATH, URLS } from '../../constants'

import HeaderIcon from '../../assets/imagens/icon-beneficios-tag.svg'
import TagBrandIneditos from '../../assets/imagens/tag-brand-ineditos.png'
import TagBrandCuradoria from '../../assets/imagens/tag-brand-curadoria.png'
import TagBoxCuradoria from '../../assets/imagens/box-curadoria.jpg'
import TagBoxIneditos from '../../assets/imagens/box-ineditos.jpeg'
import SubscriptionCard from '../../components/SubscriptionCard/SubscriptionCard'
import PreventLeavingModal from '../../components/PreventLeavingModal/PreventLeavingModal'

const getSetupUrl = () => {
  return URLS.SETUP_ASSINATURA.split( '/' ).pop()
}

const getCardData = ( theme ) => ( {
  [ `${MODALIDADE_CURADORIA.id}` ]: {
    'buttonColor': theme.palette[ 'CUR-400' ],
    'buttonHandleOnClick': () => null,
    'buttonLabel': 'QUERO CURADORIA',
    'featuredImage': TagBoxCuradoria,
    'mainTexts': [
      'Obras indicadas por grandes nomes da cultura nacional e internacional com histórias pouco conhecidas do grande público, para que você explore e descubra além da sua estante. São livros reflexivos que vão lhe tirar da zona de conforto. Ideal para quem já tem o hábito de leitura consolidado. Você vai terminar essa leitura com muitos questionamentos!',
      'Exemplos de temáticas enviadas neste clube: drama, imigração, pautas de desigualdade social.'
    ],
    'subscriptionIcon': TagBrandCuradoria,
  },
  [ `${MODALIDADE_INEDITOS.id}` ]: {
    'buttonColor': theme.palette[ 'INE-300' ],
    'buttonHandleOnClick': () => null,
    'buttonLabel': 'QUERO INÉDITOS',
    'featuredImage': TagBoxIneditos,
    'mainTexts': [
      'Best-sellers internacionais ainda não lançados no Brasil! São livros contemporâneos, de leitura rápida e envolvente - você não vai conseguir parar de ler! Obras muito bem avaliadas pelo público e que estão fisgando muitos leitores ao redor do mundo. Ideal para quem quer desenvolver ou retomar o hábito de leitura.',
      'Exemplos de temáticas enviadas neste clube: suspense, romances românticos, dramas familiares.'
    ],
    'subscriptionIcon': TagBrandIneditos,
  },
} )

function listenToExitStep( setShowPreventLeavingModal ) {
  function handleBeforeUnload( event ) {
    event.preventDefault()
    event.returnValue = ''
  }

  function handlePopState() {
    navigate( 'setup-assinatura-clube' )
    setShowPreventLeavingModal( true )
  }

  window.addEventListener( 'beforeunload', handleBeforeUnload )
  window.addEventListener( 'popstate', handlePopState )

  return () => {
    window.removeEventListener( 'beforeunload', handleBeforeUnload )
    window.removeEventListener( 'popstate', handlePopState )
  }
}
const SetupAssinaturaEscolhaClube = ( { enableLoading } ) => {
  const {
    dadosGlobaisAssociado,
    setShouldShowMenu,
    shouldShowSetupUserData,
    shouldShowSetupSubscriptionSelect,
    setShouldShowSetupUserData,
    setShouldShowSetupSubscriptionSelect
  } = useGlobal()
  const [ isLoading, setIsLoading ] = useState( enableLoading )
  const [ showPreventLeavingModal, setShowPreventLeavingModal ] = useState( false )
  const [ modalidadeSelecionada, setModalidadeSelecionada ] = useState( null )
  const theme = useTheme().v2

  useEffect( () => {
    setShouldShowMenu( false )
    return listenToExitStep( setShowPreventLeavingModal )
  }, [] )

  useEffect( () => {
    if ( !shouldShowSetupSubscriptionSelect && ( shouldShowSetupUserData !== null && shouldShowSetupUserData ) ) {
      navigate( getSetupUrl(), {
        'replace': true,
        'state': { modalidadeSelecionada }
      } )
    } else if ( !shouldShowSetupSubscriptionSelect && !shouldShowSetupUserData ) {
      setShouldShowMenu( true )
      navigate( ROUTE_BASEPATH, { 'replace': true } )
    }
  }, [ shouldShowSetupSubscriptionSelect, shouldShowSetupUserData ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      setIsLoading( false )
    }
  }, [ dadosGlobaisAssociado ] )


  const handleOnClick = async( idCategoriaSelecionada ) => {
    setIsLoading( true )

    const { 'assinaturas': [ assinatura ] } = dadosGlobaisAssociado

    const [
      [ venda ],
      { 'data': { 'planos': planosCuradoria } },
      { 'data': { 'planos': planosIneditos } },
    ] = await Promise.all( [
      getVendasPorAssinatura( assinatura.id ),
      getPlanoPorModalidade( MODALIDADE_CURADORIA.id ),
      getPlanoPorModalidade( MODALIDADE_INEDITOS.id )
    ] )
    const planosTag = {
      [ MODALIDADE_CURADORIA.id ]: { 'nomeModalidade': MODALIDADE_CURADORIA.visualizacao, 'planos': planosCuradoria },
      [ MODALIDADE_INEDITOS.id ]: { 'nomeModalidade': MODALIDADE_INEDITOS.visualizacao, 'planos': planosIneditos },
    }

    const { 'id': idVenda, 'plano_id': idPlanoOriginal, 'categoria_id': idCategoriaOriginal } = venda

    const alterouCategoria = idCategoriaOriginal !== idCategoriaSelecionada
    const planoOriginal = planosTag[ `${idCategoriaOriginal}` ].planos.find( plano => plano.id === idPlanoOriginal )
    const planoSelecionado = alterouCategoria
      ? planosTag[ `${idCategoriaSelecionada}` ].planos
        .find( plano => plano.isFidelidade === planoOriginal.isFidelidade
          && plano.isPresente === planoOriginal.isPresente
          && plano.tipo === planoOriginal.tipo )
      : planoOriginal

    try {
      await escolherPlano( { 'idPlano': planoSelecionado.id, idVenda } )
      setModalidadeSelecionada( planosTag[ idCategoriaSelecionada ].nomeModalidade )
      setShouldShowSetupUserData( true )
      setShouldShowSetupSubscriptionSelect( false )
    } catch ( error ) {
      console.error( error.message )
    } finally {
      setIsLoading( false )
    }
  }

  const handleStayInPage = () => {
    setShowPreventLeavingModal( false )
  }

  const handleProceed = () => {
    setShowPreventLeavingModal( false )
    window.history.back()
  }


  if ( isLoading && !showPreventLeavingModal ) {
    return (
      <S.LoadingContainer>
        <InlineLoader />
      </S.LoadingContainer>
    )
  }

  const cardData = getCardData( theme )
  return (
    <>
      <PreventLeavingModal
        cancelActionButtonLabel="VOLTAR PARA CADASTRO"
        message="O cadastro dos seus dados é muito importante para personalizar sua experiência e para que você consiga acessar sua conta na Área dos Associados."
        onCancelActionClick={ handleStayInPage }
        onProceedClick={ handleProceed }
        proceedButtonLabel="FECHAR CADASTRO"
        show={ showPreventLeavingModal }
      />

      <BaseCard>
        <S.Container>
          <S.HeaderIconContainer>
            <img
              alt=""
              src={ HeaderIcon }
              width="100%"
            />
          </S.HeaderIconContainer>

          <S.ContentContainer>
            <Typography
              as="h2"
              color="TAG3-400"
              variant="subtitle-large-bold"
            >
              Estamos felizes por você fazer parte da TAG!
            </Typography>

            <Typography
              as="span"
              color="TAG1-700"
              variant="text-medium-regular"
            >
              Você acaba de começar uma nova história na sua relação com os livros.
            </Typography>
          </S.ContentContainer>

          <S.ContentContainer>
            <Typography
              as="span"
              color="TAG1-700"
              variant="subtitle-medium-bold"
            >
              O seu primeiro passo é escolher que tipo de livro você deseja receber:
            </Typography>

            <Typography
              as="span"
              color="TAG1-700"
              variant="text-small-regular"
            >
              Esta escolha não poderá ser desfeita mais tarde, será necessário cancelar e assinar novamente caso queira mudar de clube.
            </Typography>
          </S.ContentContainer>

          <S.GridContainer>
            <S.SubscriptionGrid>
              { Object.entries( cardData ).map( ( [ idMmodalidade, data ] ) => (
                <SubscriptionCard
                  buttonColor={ data.buttonColor }
                  buttonFontColor={ data.buttonFontColor }
                  buttonHandleOnClick={ () => handleOnClick( idMmodalidade ) }
                  buttonLabel={ data.buttonLabel }
                  featuredImage={ data.featuredImage }
                  key={ idMmodalidade }
                  mainTexts={ data.mainTexts }
                  subscriptionIcon={ data.subscriptionIcon }
                />
              ) ) }
            </S.SubscriptionGrid>
          </S.GridContainer>

          <Typography
            as="span"
            color="TAG1-700"
            variant="text-small-regular"
          >
            Esta escolha não poderá ser desfeita mais tarde, será necessário cancelar e assinar novamente caso queira mudar de clube.
          </Typography>

        </S.Container>
      </BaseCard>
    </>
  )
}


SetupAssinaturaEscolhaClube.propTypes = {
  'enableLoading': bool,
}

SetupAssinaturaEscolhaClube.defaultProps = {
  'enableLoading': true,
}

export default SetupAssinaturaEscolhaClube
